import { IconButton, Stack, Typography } from "@mui/material";
import {
  CoffeeSolidStandardIcon,
  PlayCircleIcon,
} from "@/components/common/icons";
import {
  GREY,
  SUCCESS,
  SUCCESS_PRIMARY,
  WARNING_PRIMARY,
} from "@/config/mui/colorPalette";

type OnBreakWorkShiftsTrackerProps = {
  shiftDurationSeconds: number | undefined;
  showAdditionalInfo: boolean;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function OnBreakWorkShiftsTracker({
  shiftDurationSeconds,
  showAdditionalInfo,
  handleClick,
}: OnBreakWorkShiftsTrackerProps) {
  const totalSeconds = Math.floor((shiftDurationSeconds ?? 0) % 60);
  const totalMinutes = Math.floor(((shiftDurationSeconds ?? 0) / 60) % 60);
  const totalHours = Math.floor((shiftDurationSeconds ?? 0) / 60 / 60);

  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
      {showAdditionalInfo && (
        <>
          <CoffeeSolidStandardIcon size={20} color={WARNING_PRIMARY} />
          <Typography variant="paragraphSmall" noWrap>
            You are on a break
          </Typography>
          <span style={{ color: GREY[40] }}>•</span>
          {shiftDurationSeconds !== undefined && (
            <Typography variant="labelSmall">
              {totalHours}:{totalMinutes.toString().padStart(2, "0")}:
              {totalSeconds.toString().padStart(2, "0")}
            </Typography>
          )}
        </>
      )}
      <IconButton
        onClick={handleClick}
        disableRipple
        sx={{
          padding: "2px !important",
          mx: "6px",
          "&:hover": {
            backgroundColor: SUCCESS[20],
          },
        }}
      >
        <PlayCircleIcon size={32} color={SUCCESS_PRIMARY} />
      </IconButton>
    </Stack>
  );
}
